<template>
  <div>
    <h1 class="text-3xl text-center uppercase mb-24">Offerte voor op maat gemaakte slagboom</h1>
    <p class="text-xl text-center mb-3">Onze verwachte prijs excl. btw:</p>
    <p class="text-5xl text-center mb-24">{{ offerPrice }}</p>

    <div class="mx-auto">
      <p class="text-xl text-center mb-3">Definitieve prijs weten? Wij mailen u graag:</p>

      <div class="w-96 mx-auto my-3 text-primary flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="h-14 w-14 mr-3">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
        </svg>

        <input class="text-center w-96 border-2 border-primary bg-transparent py-2 px-4" type="text"
          v-model="contactpersoon" placeholder="Contactpersoon" />
      </div>
      <div class="w-96 mx-auto my-3 text-primary flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-14 w-14 mr-3" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
        <input class="text-center w-96 border-2 border-primary bg-transparent py-2 px-4" type="email" v-model="email"
          placeholder="Uw e-mailadres" />
      </div>
      <div class="w-96 mx-auto my-3 text-primary flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="h-14 w-14 mr-3">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
        </svg>


        <input class="text-center w-96 border-2 border-primary bg-transparent py-2 px-4" type="text" v-model="telefoon"
          placeholder="Telefoon" />
      </div>

      <div class="w-96 mx-auto my-3 text-primary flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-14 w-14 mr-3">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
        </svg>

        <input class="text-center w-96 border-2 border-primary bg-transparent py-2 px-4" type="text" v-model="locatieSlagboom"
          placeholder="Locatie voor de slagboom" />
      </div>

      <div class="w-48 mx-auto mt-16 mb-3">
        <button @click="setValueChildAndSend('eMail', 0, email, contactpersoon, telefoon, locatieSlagboom)"
          class="btn-primary text-center font-bold w-48">Verzenden</button>
      </div>
    </div>

    <btn-group-bottom previous="stap-5" next />
  </div>
</template>

<script>
export default {
  name: 'Verzenden',
  data() {
    return {
      offerPrice: 0
    }
  },
  props: {
    pages: Array,
    selectedValues: Array,
    totalPrice: Number,
  },
  methods: {
    async getFullNames() {
      var a = this.selectedValues;
      var i, n = a.length;
      for (i = 0; i < n; ++i) {
        this.offerPrice = this.offerPrice + a[i].value;
      }

      this.offerPrice = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(this.offerPrice);

    },
    setValueChildAndSend(key, value, email, contactpersoon, telefoon, locatieSlagboom) {
      //alert('yoeh' + key + ' ' + value + ' ' + title);
      this.$emit("setValue", 'contactpersoon', 0, contactpersoon, true);
      this.$emit("setValue", 'telefoon', 0, telefoon);
      this.$emit("setValue", 'locatieSlagboom', 0, locatieSlagboom);
      this.$emit("setValueAndSend", key, value, email, true);
    },
  },
  mounted: function () {
    this.getFullNames();
  },
  inheritAttrs: false, // disable 'non-props' warning
};



</script>
